let validateCustomThousand = (str) => {
  const regexp = /[a-zA-Z]/
  return !regexp.test(str)
}

export default validateCustomThousand
